import { Component, Output, EventEmitter } from '@angular/core';
import { ConfigService } from 'src/app/service/config.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  public isExpanded = true;
  public css: string;
  public projectColor: string;
  public IsSettingsMenu: boolean;
  public IsProfileMenu: boolean;
  public IsAlertMenu: boolean;
  public IsHelpMenu: boolean;
  constructor(config: ConfigService) {
    this.css = config.values.projectCSS;
    this.projectColor = config.values.projectColor;
    this.IsSettingsMenu = config.values.enableSystemSettings;
    this.IsProfileMenu = config.values.enableSystemProfile;
    this.IsAlertMenu = config.values.enableSystemAlerts;
    this.IsHelpMenu = config.values.enableSystemHelp;
  }

  @Output("isExpanded")
  outIsExpanded = new EventEmitter<boolean>();

  toggle() {
    console.log('toggle');
    this.isExpanded = !this.isExpanded;
    this.outIsExpanded.emit(this.isExpanded);
  }
}
